import PropTypes from 'prop-types';
import React from 'react';
import cn from 'classnames';
import { childrenShape } from '@bibliocommons/bc-prop-types';

import TableCell from './TableCell';
import './TableRow.scss';

export default function TableRow({ className, children, selected, renderSelectionControl }) {
  const selectableCell = renderSelectionControl && (
    <TableCell className="table-row__selectable-cell">{renderSelectionControl()}</TableCell>
  );

  const classNames = cn('cp-table-row', className, {
    'table-row--selectable': !!selectableCell,
    'table-row--selected': selected
  });

  return (
    <tr className={classNames}>
      {selectableCell}
      {children}
    </tr>
  );
}

TableRow.propTypes = {
  className: PropTypes.string,
  children: childrenShape.isRequired,
  selected: PropTypes.bool,
  renderSelectionControl: PropTypes.func
};
